import { dynamicMenusComponent } from './dynamic-menus.component';
import { DynamicMenusService } from './dynamic-menus.service'

export const dynamicMenus = angular
    .module('components.dynamicMenus', [])
    .service("DynamicMenusService", DynamicMenusService)
    .component('dynamicMenus', dynamicMenusComponent)
    .config(($stateProvider, $urlMatcherFactoryProvider) => {
        'ngInject';

        $urlMatcherFactoryProvider.type('url', {});

        $stateProvider
            .state('DynamicMenus', {
                url: '/{url:url}',
                component: 'dynamicMenus',
                resolve: {
                    menuDetails($stateParams, DynamicMenusService) {
                        'ngInject';

                        return DynamicMenusService.getMenuDetailsByUrl($stateParams.url);
                    },
                    slugUrl($stateParams) {
                        'ngInject';

                        return $stateParams.url;
                    }
                }
            });
    })
    .name;


// WEBPACK FOOTER //
// ./src/app/components/dynamic-menus/dynamic-menus.module.js